import { render } from "./RegistrationVerifyNumberCode.vue?vue&type=template&id=d28b6ac0&scoped=true&ts=true"
import script from "./RegistrationVerifyNumberCode.vue?vue&type=script&lang=ts"
export * from "./RegistrationVerifyNumberCode.vue?vue&type=script&lang=ts"

import "./RegistrationVerifyNumberCode.vue?vue&type=style&index=0&id=d28b6ac0&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d28b6ac0"]])

export default __exports__